import { Injectable, linkedSignal, signal } from '@angular/core';
import { LOADER_BLOCKLIST, MIN_LOADING_DISPLAY } from '../constants/app.constants';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  loading = signal(true);
  popupBlocked = signal(false);
  qhcLoginAttempt = signal(false);
  overlayBlocked = signal(false);
  inFlightRequests: string[] = [];
  loadingStartTime?: number;
  timedOut = signal(false);

  constructor(private user: UserService) {
    this.loading = linkedSignal(() => this.user.permissions().length < 1 || this.inFlightRequests.length > 0)
  }

  add(url: string) {
    if (! this.loadingStartTime) {
      this.loadingStartTime = new Date().getTime();
      // console.log('new loader start');
    }
    this.inFlightRequests.push(url);
    if (!this.loading()) {
      this.loading.set(true);
    }
  }

  remove(urlOfCompletedRequest: string) {
    const reqs: string[] = [];
    this.inFlightRequests.map(url => {
      if (! (url === urlOfCompletedRequest)) {
        reqs.push(url);
      }
    });
    this.inFlightRequests = reqs;
    // console.log(this.inFlightRequests);
    if (this.inFlightRequests.length === 0) {
      // ensure loading indicator shows for minimum time
      const now = new Date().getTime();
      // time remaining is minimum display less the elapsed time since the first request started
      // if the elapsed time is greater than the minimum - set the remaining to 0
      const elapsed = now - (this.loadingStartTime || now);
      const loadingTimeRemaining = Math.max(0, MIN_LOADING_DISPLAY - elapsed);
      // console.log(`elapsed: ${elapsed} and remaining: ${loadingTimeRemaining}`);
      setTimeout(() => {
        // check again in case new requests
        // were added in the minimum display period
        if (this.inFlightRequests.length === 0) {
          this.loading.set(false);
          this.loadingStartTime = undefined;
          // console.log('reset loader');
        }
      }, loadingTimeRemaining);
    }
  }

  isBlockedUrl(url: string): boolean {
    let blocked = false;
    LOADER_BLOCKLIST.map(b => {
      const re = new RegExp(`api\/.*${b}`,'g');
      if ((re.test(url))) blocked = true;
    });
    return blocked;
  }
}
